var $ = global.jQuery
    , ko               = require('knockout')
    , core             = require('CoreModule')
    , events           = core.Events
    , controllerEvents = require('ControllerEvents.js')
    , helpers          = core.Helpers;


var PaginationControlViewModel = function (init) {

    var self         = this;
    self.CurrentPage = init.CurrentPage;
    self.PageSize    = init.PageSize;
    self.TotalPages  = init.TotalPages;
    console.log("pagination control", this);

    self.FirstPage = function(){ 
        self.SetPage(0);
    }

    self.LastPage = function(){
        self.SetPage(self.TotalPages - 1);
    }
    self.SetPage = function (paginationItem) {

        console.log('pagination', paginationItem);

        if (self.busy() || paginationItem === undefined || paginationItem === null) return;

        var requestedPage = ko.utils.unwrapObservable(paginationItem) + 1;
        
        console.log('requestedPage', requestedPage);

        var currentPage = self.CurrentPage();
        var totalPages  = self.TotalPages();

        var pageNumber;
        if (requestedPage === 0) { // previous
            pageNumber = currentPage <= 1 ? -99 : currentPage - 1;
        } else if (requestedPage > totalPages) { // next
            pageNumber = currentPage >= totalPages ? -99 : currentPage + 1;
        } else {
            pageNumber = requestedPage;
        }
        if (pageNumber === -99) {
            console.log('already on first/last page');
            return;
        }

        events.emitter.emit(events.pagination_page_change, pageNumber);
    }



    self.InterControllerEmitter = init.InterControllerEmitter;
    self.helpers                = helpers;
    self.busy                   = ko.observable();


    PaginationControlViewModel.prototype.dispose = function () {
        console.error("Disposing PictureFiltersViewModel....");
    }
}


module.exports = {
    viewModel: PaginationControlViewModel
    , template: require('PaginationControlView.html')
    , title: ''

};